<template>
  <modal
    name="video-static"
    :classes="['v--modal', 'responsive-modal']"
    :width="modalWidth"
    :height="modalHeight"
    :adaptive="true"
  >
    <div class="video-static-container">
      <div class="video-frame">
        <iframe 
          width="100%" 
          height="100%" 
          :src="modalSrc"
          title="YouTube video player" 
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
          referrerpolicy="strict-origin-when-cross-origin" 
          allowfullscreen>
        </iframe>
      </div>      
    </div>
  </modal>
</template>

<script>
  import store from '../store/store';

  export default {
    name: 'VideoStaticModal',
     props: {
    videoType: {
       type: String,
    required: true,
    validator: value => ['presentation', 'realExample'].includes(value)
    }
  },
    data() {
      return {
        windowWidth: window.innerWidth
      }
    },
    mounted() {
      window.addEventListener('resize', this.onResize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.onResize);
    },
    methods: {
      onResize() {
        this.windowWidth = window.innerWidth;
      }, 
    },
    computed: {
      lang: () => {
        return store.state.lang;
      },
      modalWidth() {
        return this.windowWidth < 768 ? (this.windowWidth - 40) : 980;
      },
      modalHeight() {
        return this.windowWidth < 768 ? ((this.windowWidth - 40) * 9/16) : 570;
      },
      modalSrc() {
        if (this.videoType === 'presentation') {
          return this.lang === 'pl'
            ? 'https://www.youtube.com/embed/9x3c1CYNR6U?si=s5ENZHSqKZc5gPmM'
            : 'https://www.youtube.com/embed/NSiyhMJlKdU?si=e5QS5pAt9McaWk7e';
        }
        if (this.videoType === 'realExample') {
          return 'https://www.youtube.com/embed/ur2bDF2aYSs?si=iwWV_tXOgOhdBXf-'
        }
      }
    }
  }
</script>

<style scoped>
  .video-static-container {
    height: 100%;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
  }
  .video-frame {
    position: relative;
    height: 100%;
    width: 100%;
    border-radius: 4px;
    overflow: hidden;
  }
  .video-frame iframe {
    position: absolute;
    left: 0;
    width: 100%;
    height: calc(100% - 1px);
    border: 0;
    background-color: white;
  }

  @media (max-width: 768px) {
    .video-static-container {
      padding: 10px;
    }
    
    .video-frame {
      border-radius: 2px;
    }
  }

</style>



// WEBPACK FOOTER //
// VideoStaticModal.vue?29a15122